import { RouterProvider } from 'react-router-dom';
import router from 'routes';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { persistor, store } from './redux/store';
import { ModalsProvider } from '@mantine/modals';
import { PersistGate } from 'redux-persist/integration/react';
import { notifications } from 'notifications';
import { getErrorMessage } from 'services/getErrorMessage';
import { axios } from 'services/axios';

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      retry: false,
      onSuccess: () => {
        notifications.success({
          message: 'Success',
        });
      },
      onError: (error) => {
        notifications.error({
          title: 'Error',
          message: getErrorMessage(error),
        });
      },
    },
    queries: { retry: false, refetchOnWindowFocus: false },
  },
});

axios.interceptors.request.use(
  function (config) {
    config.headers = Object.assign(config.headers, {
      Authorization: 'Bearer ' + store.getState()?.auth?.token,
    });
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <MantineProvider
            withGlobalStyles
            withNormalizeCSS
            theme={{
              fontFamily: "'Poppins', sans-serif",
              defaultGradient: { from: 'teal', to: 'blue', deg: 60 },
              breakpoints: {
                xs: '30em',
                sm: '48em',
                md: '64em',
                lg: '74em',
                xl: '90em',
              },
              colors: {
                brand: [
                  '#E6FCF5',
                  '#C3FAE8',
                  '#96F2D7',
                  '#63E6BE',
                  '#38D9A9',
                  '#20C997',
                  '#12B886',
                  '#0CA678',
                  '#099268',
                  '#087F5B',
                ],
              },
              primaryColor: 'brand',
            }}
          >
            <ModalsProvider modalProps={{ keepMounted: false }}>
              <Notifications position="top-center" zIndex={1000} />
              <RouterProvider router={router} />
            </ModalsProvider>
          </MantineProvider>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
